<template>
  <component
    :is="clickable ? BaseLink : 'div'"
    ref="elementRef"
    class="flex center py-px c-$c"
    :class="{ 'hover:c-$ch underlined duration': clickable }"
    :data-cta="targets[0]?.delocalizedTracking"
    :style="{
      'background': background,
      '--c': textColor,
      '--ch': hoverLinkColor || textColor,
    }"
    :target="targets[0]?.targetAttribute"
    :to="targets[0]?.url"
    @click="handlePromotionClick"
  >
    <cms-rich-text
      class="line-clamp-2"
      :content="{ richText }"
      :links-hover-color="hoverLinkColor || textColor"
    />
  </component>
</template>

<script lang="ts" setup>
import type { Message, PromoBarColors } from '#types/components/cms/promo-bar'
import { BaseLink } from '#components'
import { DynamicFieldsKey } from '#content/contexts/dynamic-fields'

const { content } = defineProps<{
  content: Message
}>()
const { elementRef, handlePromotionClick } = usePromotionTracking(content.promotionTracking, content.name)

const { clickable, hoverLinkColor, richText, targets = [], textColor, background, sectionId = '', id } = content
const isLowContrast = hasHighBrightness(textColor)

const colors = useState<Record<string, PromoBarColors>>('promoBarColors', () => ({}))

onMounted(() => colors.value[sectionId || id] = { background, textColor, hoverLinkColor, isLowContrast })

content.countdown && provide(DynamicFieldsKey, { countdown: content.countdown })
</script>
